import i18next from 'i18next';
import * as yup from 'yup';

const t = i18next.t;

export const inviteMemberSchema = yup.object().shape({
    teamMembers: yup
        .array()
        .of(
            yup.object().shape({
                email: yup.string().email(t('Organization.Validation.Team_Members.Invalid_Email')).required(t('Organization.Validation.Team_Members.Email_Required')),
                role: yup.string().required(t('Organization.Validation.Team_Members.Role_Required')),
            })
        )
        .min(1, t('Organization.Validation.Team_Members.Min_One_Member'))
        .required(t('Organization.Validation.Team_Members.Members_Required')),
});
